import { render, staticRenderFns } from "./MemoIntro.vue?vue&type=template&id=58e88d33&scoped=true&"
import script from "./MemoIntro.vue?vue&type=script&lang=js&"
export * from "./MemoIntro.vue?vue&type=script&lang=js&"
import style0 from "./MemoIntro.vue?vue&type=style&index=0&id=58e88d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e88d33",
  null
  
)

/* custom blocks */
import block0 from "./MemoIntro.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports